/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManufacturerTarget } from '../../models/manufacturer-target';
import { UpdateManufacturerTargetDto } from '../../models/update-manufacturer-target-dto';

export interface UpdateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params {
  manufacturerId: number;
  id: number;
      body: UpdateManufacturerTargetDto
}

export function updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget(http: HttpClient, rootUrl: string, params: UpdateOneBaseMgmtManufacturerTargetControllerManufacturerTarget$Params, context?: HttpContext): Observable<StrictHttpResponse<ManufacturerTarget>> {
  const rb = new RequestBuilder(rootUrl, updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget.PATH, 'patch');
  if (params) {
    rb.path('manufacturerId', params.manufacturerId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManufacturerTarget>;
    })
  );
}

updateOneBaseMgmtManufacturerTargetControllerManufacturerTarget.PATH = '/api/mgmt/manufacturer/{manufacturerId}/targets/{id}';
